import { Component, Input } from '@angular/core'

@Component({
    selector: 'fm-availability-list-header',
    templateUrl: './availability-list-header.component.html',
    styleUrls: ['./availability-list-header.component.scss'],
    standalone: false,
})
export class AvailabilityListHeaderComponent {
    @Input() listTitle: string | null = null
    @Input() listIcon: any = null
}
